import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    const isNewForm = JSON.parse(this.element.dataset.isNewForm);
    $(this.element).sortable({
      axis: "y",
      handle: ".handle",
      update: (e, ui) => {
        if (!isNewForm) {
          Rails.ajax({
            url: this.data.get("url"),
            type: "PATCH",
            data: $(this.element).sortable("serialize")
          });
        }

        document.querySelectorAll('.anamnese-question-position').forEach((input, index) => {
          input.value = index + 1
        })
      }
    });
  }
}
